// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.financial-target-first-form-toggle-container {
    display: flex;
    column-gap: 12px;
    margin-bottom: 29px;
}

.financial-target-first-form-dialog-first-section {
    display: flex;
    row-gap: 16px;
    flex-direction: column;
}

.financial-target-first-form-container {
    display: flex;
    flex: 1;
}

.financial-target-first-form-input-container {
    width: 360px;
}

.financial-target-first-form-form-label {
    font-weight: 700;
}

.financial-target-first-form-separator {
    width: 1px;
    background-color: #bdbdbd;
    position: relative;
    margin: 0 28px;
}

.financial-target-first-form-separator::after {
    content: "";
    position: relative;
    display: block;
    height: 16px;
    width: 16px;
    border-top: 1px solid #bdbdbd;
    border-right: 1px solid #bdbdbd;
    background-color: white;
    top: calc(50% - 8px);
    left: -7px;
    transform: rotate(45deg);
}

.wizard-toggle.is-checked > div > button {
    background-color: #00a9a4;
}

.wizard-toggle.is-checked > div > button:hover {
    background-color: #00a9a4;
}

.financial-target-first-form-dialog-second-section {
    width: 260px;
}
`, "",{"version":3,"sources":["webpack://./client/components/product-collection/footer/components/financial-target-wizard/wizard-step-one.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,OAAO;AACX;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,WAAW;IACX,6BAA6B;IAC7B,+BAA+B;IAC/B,uBAAuB;IACvB,oBAAoB;IACpB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".financial-target-first-form-toggle-container {\n    display: flex;\n    column-gap: 12px;\n    margin-bottom: 29px;\n}\n\n.financial-target-first-form-dialog-first-section {\n    display: flex;\n    row-gap: 16px;\n    flex-direction: column;\n}\n\n.financial-target-first-form-container {\n    display: flex;\n    flex: 1;\n}\n\n.financial-target-first-form-input-container {\n    width: 360px;\n}\n\n.financial-target-first-form-form-label {\n    font-weight: 700;\n}\n\n.financial-target-first-form-separator {\n    width: 1px;\n    background-color: #bdbdbd;\n    position: relative;\n    margin: 0 28px;\n}\n\n.financial-target-first-form-separator::after {\n    content: \"\";\n    position: relative;\n    display: block;\n    height: 16px;\n    width: 16px;\n    border-top: 1px solid #bdbdbd;\n    border-right: 1px solid #bdbdbd;\n    background-color: white;\n    top: calc(50% - 8px);\n    left: -7px;\n    transform: rotate(45deg);\n}\n\n.wizard-toggle.is-checked > div > button {\n    background-color: #00a9a4;\n}\n\n.wizard-toggle.is-checked > div > button:hover {\n    background-color: #00a9a4;\n}\n\n.financial-target-first-form-dialog-second-section {\n    width: 260px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
